import React from "react";
import { useDispatch } from "react-redux";
import { find as _find, set as _set } from "lodash";
import MaterialTable from "material-table";

import { updateCompanyContract } from "../../helpers/services/CompanyServices";

import UserSelectionInput from "../UserSelectionInput/UserSelectionInput.component";
import CompanyActionTypes from "../../redux/company/company.types";

export default ({ companyId, contracts }) => {
  console.log("contracts", contracts);
  const dispatch = useDispatch();
  console.log(contracts);
  const [contractsList, setContractsList] = React.useState(contracts);
  var contractsColumns = [
    { title: "id", field: "id", hidden: true },
    {
      title: "Jahre",
      field: "contract_year",
      editComponent: (props) => <div>{props.value}</div>,
    },
    {
      title: "GvL",
      field: "main_sales_lead_id",
      render: (rowData) => (
        <React.Fragment>
          {(rowData.main_sales_lead_first_name || "") +
            " " +
            (rowData.main_sales_lead_last_name || "")}
        </React.Fragment>
      ),
      editComponent: (props) => (
        <UserSelectionInput
          defaultValue={{
            first_name: props.rowData.main_sales_lead_first_name || "",
            last_name: props.rowData.main_sales_lead_last_name || "",
          }}
          onValueChange={(value) => {
            props.onRowDataChange({
              ...props.rowData,
              main_sales_lead_first_name: value ? value.first_name : "",
              main_sales_lead_last_name: value ? value.last_name : "",
              main_sales_lead_email: value ? value.email : "",
              main_sales_lead_id: value ? value.id : "",
            });
          }}
          __props={props}
        />
      ),
    },
  ];

  // const refreshData = async () => {
  //     console.log(companyId);
  //     const response = await getCompanySubsidiaries(companyId);
  //     dispatch({
  //         type: CompanyActionTypes.RETRIEVE_COMPANY_DETAILS,
  //         payload: { subsidiaries: response },
  //     });
  //     return;
  // };
  const handleRowUpdate = async (newData, oldData, resolve, reject) => {
    console.log(newData);
    await updateCompanyContract({
      company_id: companyId,
      country_code: "DEU",
      ...newData,
    });
    let _contractsList = [...contractsList];
    let c = _find(_contractsList, { contract_year: newData.contract_year });
    _set(c, "main_sales_lead_first_name", newData.main_sales_lead_first_name);
    _set(c, "main_sales_lead_last_name", newData.main_sales_lead_last_name);
    _set(c, "main_sales_lead_id", newData.main_sales_lead_id);
    _set(c, "main_sales_lead_email", newData.main_sales_lead_email);
    setContractsList(_contractsList);
    resolve();
  };

  return (
    <MaterialTable
      title=""
      columns={contractsColumns}
      data={contractsList || []}
      options={{
        actionsColumnIndex: -1,
      }}
      localization={{
        body: {
          emptyDataSourceMessage: "Keine Einträge",
          addTooltip: "Hinzufügen",
          deleteTooltip: "Löschen",
          editTooltip: "Bearbeiten",
          filterRow: {
            filterTooltip: "Filter",
          },
          editRow: {
            deleteText: "Diese Zeile wirklich löschen?",
            cancelTooltip: "Abbrechen",
            saveTooltip: "Speichern",
          },
        },
        grouping: {
          placeholder: "Spalten ziehen ...",
          groupedBy: "Gruppiert nach:",
        },
        header: {
          actions: "Aktionen",
        },
        pagination: {
          labelDisplayedRows: "{from}-{to} von {count}",
          labelRowsSelect: "Zeilen",
          labelRowsPerPage: "Zeilen pro Seite:",
          firstAriaLabel: "Erste Seite",
          firstTooltip: "Erste Seite",
          previousAriaLabel: "Vorherige Seite",
          previousTooltip: "Vorherige Seite",
          nextAriaLabel: "Nächste Seite",
          nextTooltip: "Nächste Seite",
          lastAriaLabel: "Letzte Seite",
          lastTooltip: "Letzte Seite",
        },
        toolbar: {
          addRemoveColumns: "Spalten hinzufügen oder löschen",
          nRowsSelected: "{0} Zeile(n) ausgewählt",
          showColumnsTitle: "Zeige Spalten",
          showColumnsAriaLabel: "Zeige Spalten",
          exportTitle: "Export",
          exportAriaLabel: "Export",
          exportName: "Export als CSV",
          searchTooltip: "Suche",
          searchPlaceholder: "Suche",
        },
      }}
      editable={{
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
            handleRowUpdate(newData, oldData, resolve, reject);
          }),
      }}
    />
  );
};
